module.exports = require("../containers/drawer/Drawer.vue");